/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Qty_LabelInputs */



/**
* | output |
* | --- |
* | "Quantity" |
*
* @param {Promo_Movement_Qty_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_qty_label = /** @type {((inputs?: Promo_Movement_Qty_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Qty_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quantité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cantidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Quantidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quantità")
	return /** @type {LocalizedString} */ ("Quantity")
});